// components/AccountList/AccountListModalForm.js
import React from "react";
import { Button, Grid, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import AppForm from "components/Shared/AppForm";

const INITIAL_STATE = {
  name: "",
};

const AccountListModalForm = ({
  label = "Add Fee Item",
  isBusy = false,
  onSubmit = () => {},
  onCancel = () => {},
  chargeType = "Charge",
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: INITIAL_STATE,
  });

  const handleFormSubmit = (data) => {
    const payload = {
      name: data.name,
      type: chargeType === "Charge" ? "Shipment Fees" : "Shipment Discount",
      parentName: chargeType === "Charge" ? "Shipment Fees" : "Shipment Discount",
      level: 1,
      maxLevel: 1,
      isActive: true,
    };
    onSubmit(payload);
  };

  return (
    <AppForm loading={isBusy}>
      <AppForm.Content>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Item name is required" }}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  size="small"
                  label={chargeType === "Charge" ? "Charge Item Name" : "Discount Item Name"}
                  error={!!errors.name}
                  helperText={errors.name?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </AppForm.Content>
      <AppForm.Actions>
        <Button onClick={onCancel} disabled={isBusy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit(handleFormSubmit)}
          disabled={isBusy}
        >
          {label}
        </Button>
      </AppForm.Actions>
    </AppForm>
  );
};

export default AccountListModalForm;